import { ComponentProps } from "react";

export default function SearchIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.76627 1C9.9509 1 12.5325 3.58165 12.5325 6.76627C12.5325 8.1698 12.0299 9.45526 11.1964 10.4552L15 14.2587L14.2587 15L10.4552 11.1964C9.45526 12.0299 8.1698 12.5325 6.76627 12.5325C3.58165 12.5325 1 9.9509 1 6.76627C1 3.58165 3.58165 1 6.76627 1ZM6.76627 2.04841C4.16067 2.04841 2.04841 4.16067 2.04841 6.76627C2.04841 9.37187 4.16067 11.4841 6.76627 11.4841C9.37187 11.4841 11.4841 9.37187 11.4841 6.76627C11.4841 4.16067 9.37187 2.04841 6.76627 2.04841Z"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="currentColor"
      />
    </svg>
  );
}
